<script setup lang="ts">
// Consistent line icons for the quick-status / price cards. All share one
// 24×24 viewBox and stroke currentColor, so every glyph renders the same
// size and picks up the good/bad/muted color from its parent .quick-stat.
defineProps<{
  name: 'person' | 'company' | 'speedometer' | 'inspection' | 'pledge' | 'price' | 'owners' | 'camera';
}>();
</script>

<template>
  <svg
    class="quick-icon-svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <!-- personal owner -->
    <template v-if="name === 'person'">
      <circle cx="12" cy="8" r="3.4" />
      <path d="M5.5 19.5c0-3.6 2.9-6.2 6.5-6.2s6.5 2.6 6.5 6.2" />
    </template>

    <!-- corporate owner -->
    <template v-else-if="name === 'company'">
      <path d="M4 20h16" />
      <path d="M6.5 20V5.5a1 1 0 0 1 1-1H14a1 1 0 0 1 1 1V20" />
      <path d="M15 9.5h2.5a1 1 0 0 1 1 1V20" />
      <path d="M9 8h3M9 11h3M9 14h3" />
    </template>

    <!-- mileage: speedometer -->
    <template v-else-if="name === 'speedometer'">
      <path d="M4 17a8 8 0 1 1 16 0" />
      <path d="M12 17l4.2-4.2" />
      <circle cx="12" cy="17" r="1.15" fill="currentColor" stroke="none" />
      <path d="M5.6 14.2h.01M8 10.4h.01M12 9h.01M16 10.4h.01M18.4 14.2h.01" />
    </template>

    <!-- inspection: a car seen through a magnifier lens -->
    <template v-else-if="name === 'inspection'">
      <circle cx="10.3" cy="10.3" r="7.3" />
      <path d="M15.6 15.6 21 21" />
      <path d="M6 11.1l1-2.1a1.3 1.3 0 0 1 1.2-.8h4.2a1.3 1.3 0 0 1 1.2.8l1 2.1" />
      <path d="M5.7 11.1h9.2" />
      <circle cx="8.1" cy="11.7" r="0.95" />
      <circle cx="12.5" cy="11.7" r="0.95" />
    </template>

    <!-- register pledge: euro coin -->
    <template v-else-if="name === 'pledge'">
      <circle cx="12" cy="12" r="8.3" />
      <path d="M15 9.4a3.6 3.6 0 1 0 0 5.2" />
      <path d="M7.6 11.2h5.2M7.6 13h4.4" />
    </template>

    <!-- market price: euro banknote -->
    <template v-else-if="name === 'price'">
      <rect x="2.5" y="6" width="19" height="12" rx="1.8" />
      <path d="M13.9 10.4a2.6 2.6 0 1 0 0 3.2" />
      <path d="M8.4 11.6h3.4M8.4 12.9h3" />
    </template>

    <!-- back to scanner: camera -->
    <template v-else-if="name === 'camera'">
      <path
        d="M4.75 7.5h2.3l1.4-2h7.1l1.4 2h2.3A1.75 1.75 0 0 1 21 9.25v8A1.75 1.75 0 0 1 19.25 19H4.75A1.75 1.75 0 0 1 3 17.25v-8A1.75 1.75 0 0 1 4.75 7.5Z"
      />
      <circle cx="12" cy="13" r="3.6" />
    </template>

    <!-- owner count: people -->
    <template v-else-if="name === 'owners'">
      <circle cx="9" cy="9.2" r="2.7" />
      <path d="M3.6 18.5c0-3 2.4-5.1 5.4-5.1s5.4 2.1 5.4 5.1" />
      <path d="M15.4 7c1.5.3 2.6 1.6 2.6 3.2s-1.1 2.9-2.6 3.2" />
      <path d="M16.6 13.8c2.2.4 3.8 2.3 3.8 4.7" />
    </template>
  </svg>
</template>
